import { useState } from 'react';
import Snackbar, { SnackbarProps } from '@mui/material/Snackbar';
import { Alert, AlertColor } from '@mui/material';

interface SnackbarData extends SnackbarProps {
  message: string;
  severity: AlertColor;
  autoHideDuration?: number;
}

const useSnackbar = () => {
  const [snackbarData, setSnackbarData] = useState<SnackbarData | null>(null);

  const showSnackbar = (data: SnackbarData) => {
    setSnackbarData(data);
  };

  const handleSnackbarClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbarData(null);
  };

  return {
    showSnackbar,
    SnackbarComponent: snackbarData && (
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={true}
        autoHideDuration={snackbarData.autoHideDuration || 5000}
        onClose={handleSnackbarClose}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbarData.severity}
          sx={{
            width: '100%',
            color: 'black',
          }}
        >
          {snackbarData.message}
        </Alert>
      </Snackbar>
    ),
  };
};

export default useSnackbar;